import React, { PureComponent } from "react";
import { Icon } from "semantic-ui-react";
import html2canvas from "html2canvas";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as ArrowIcon } from "../../../../../assets/svg/chevron.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import ChartIndexSelector from "../ChartsOptionsSidebar/ChartIndexSelector";
import OverallShareOfVoiceForScenesChart from "./OverallShareOfVoiceForScenesCharts";
import NoData from "../NoData/NoData";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import moment from "moment-timezone";
import IntervalSelector from "../IntervalSelector";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";
import * as d3 from "d3";

import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { ProductAttributes } from "../../../../MainContent/Dashboard/ProductAttributeValues";

import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
class OverallShareOfVoiceForScenes extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showInfo: false,
            downloading: false,
            aggs_val: "default",
            showAggsDropdown: false,
            topic: "",
            index: 0,
        };

        this.container = React.createRef();
        this.chart = React.createRef();
    }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.graph_type !== this.props.graph_type && this.props.graph_type === "line" && this.props.data && !this.props.data.hasLineData) {
    //         this.props.changeGraphType("line", true);
    //     }
    // }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "IAoverallShareOfVoiceForScenes");
            });
        contextMenu.style("display", "block");
    };

    createNewFilter = (d) => {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};
        if (d.options.name === "Others") {
            let data = d.options.items.map((ele) => ele.sceneName.toLowerCase());

            newFilter.scenes = data;
            //  newFilter.logos = [this.props.data.data[this.state.index].name];
        } else {
            let value = d.options.sceneName ? d.options.sceneName : d.options.name;
            // newFilter.logos = [this.props.data.data[this.state.index].name];
            newFilter.scenes = [d.options.logoName];
        }

        if (this.props.graph_type === "line") {
            newFilter = getViewConversationDuration(d, newFilter, this.props.aggs_val, this.props.filters);
        }

        if (!this.props.chartFilterApplied) {
            newFilter.objects = this.props.ImageSystemLogos.objects;
            newFilter.logos = this.props.ImageSystemLogos.logos;
        }
        if (d.options.allSubtopicSelected) {
            newFilter.topics = [d.options.topicId];
            newFilter.subtopics = [];
        } else {
            newFilter.subtopics = d.options.subtopicId;
            newFilter.topics = [];
        }
        newFilter["image_analytics_types"] = ["scenes"];
        // newFilter.topics = [d.options.topicId];
        return newFilter;

        //this.props.handleContextMenuClick(newFilter);
    };

    handleContextMenuClick = (d) => {
        let newFilter = this.createNewFilter(d);

        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(d) {
        let newFilter = this.createNewFilter(d);

        this.props.handleDrilldownClick(newFilter);
    }

    getChart = () => {
        let data = JSON.parse(JSON.stringify(this.props.data.data[this.state.index]));
        let comparisionData = this.props.comparisionData && JSON.parse(JSON.stringify(this.props.comparisionData.data[this.state.index]));

        let options = this.props.data.data.map((d, i) => ({ label: d.name, value: i }));

        return (
            <>
                <div className="chart-item-name">
                    <ChartIndexSelector
                        selectorType="Topic"
                        currentName={data.name}
                        currentIndex={this.state.index}
                        options={options}
                        onIndexChange={this.onIndexChange}
                        widgetContainerRef={this.props.widgetContainerRef}
                    />
                </div>
                {data.value > 0 ? (
                    <OverallShareOfVoiceForScenesChart
                        // resizedCount={this.props.resizedCount}
                        data={data}
                        currentChartType={this.props.graph_type}
                        showGridLines={this.props.showGridLines}
                        showLabel={this.props.showLabel}
                        showLegend={this.props.hideCommonLegend}
                        widgetContainerRef={this.props.widgetContainerRef}
                        addContextMenuListener={this.addContextMenuListener}
                        comparisionData={comparisionData}
                        expandWidget={this.props.expandWidget}
                    />
                ) : (
                    <NoData />
                )}
            </>
        );
    };

    onIndexChange = (index) => this.setState({ index });

    increment = () => {
        if (this.props.data.data.length === 1) return;
        let index = (this.state.index + 1) % this.props.data.data.length;
        this.setState({ index });
    };

    decrement = () => {
        if (this.props.data.data.length === 1) return;
        let index = this.state.index;
        if (index === 0) index = this.props.data.data.length - 1;
        else index--;
        this.setState({ index });
    };

    renderDownloadButton = (nodata) => {
        if (!nodata && this.props.data.data) {
            if (this.props.data.data[this.state.index].value === 0) nodata = true;
        }

        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        return html2canvas(this.chart.current, { backgroundColor: options.background ? "#fff" : null }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt;
        let comparisonCsvFmt;
        if (this.props.graph_type === "line") {
            let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
            csvFmt = [["Time"]];
            let topic = this.props.data.data[this.state.index];
            topic.csvData.sort((a, b) => {
                if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                else return -1;
            });
            topic.csvData[0].data.forEach((d) => {
                csvFmt.push([moment(d.x).tz(userTz).format("YYYY-MM-DD HH:mm")]);
            });
            topic.csvData.forEach((t) => {
                csvFmt[0].push(t.name);
                t.data.forEach((d, i) => {
                    csvFmt[i + 1].push(d.y);
                });
            });

            if (this.props.comparisionData && this.props.comparisionData.data[this.state.index]) {
                comparisonCsvFmt = [[" Comparison Time"]];
                let topic = this.props.comparisionData.data[this.state.index];

                topic.csvData.sort((a, b) => {
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    else return -1;
                });

                topic.csvData[0].data.forEach((d) => {
                    comparisonCsvFmt.push([moment(d.x).tz(userTz).format("YYYY-MM-DD HH:mm")]);
                });
                topic.csvData.forEach((t) => {
                    comparisonCsvFmt[0].push(t.name);
                    t.data.forEach((d, i) => {
                        comparisonCsvFmt[i + 1].push(d.y);
                    });
                });

                csvFmt.push(...comparisonCsvFmt);

                let firstIndLen = csvFmt[0].length;
                let lastIndLen = csvFmt[csvFmt.length - 1].length;

                let length;
                if (firstIndLen > lastIndLen) length = firstIndLen;
                else length = lastIndLen;

                let arr = [];
                for (let i = 0; i < length; i++) {
                    arr.push([]);
                    for (let j = 0; j < csvFmt.length; j++) {
                        if (csvFmt[j] && csvFmt[j][i]) arr[i].push(csvFmt[j][i]);
                        else arr[i].push(0);
                    }
                }
                csvFmt = arr;
            }
        } else {
            csvFmt = [["Topic", "Scenes", "Value"]];
            let topic = this.props.data.data[this.state.index];
            topic.csvData.forEach((subtopic) => {
                csvFmt.push([topic.name, subtopic.name, subtopic.value]);
            });
        }

        downloadCSVData(csvFmt, this.props.widget.name);
    };

    // changeGraphType = (val) => {
    //     let makeApiCall = val === "line" && ["bar", "pie"].includes(this.props.graph_type) && !this.props.data.hasLineData;
    //     this.props.changeGraphType(val, makeApiCall);
    // };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="For each topic selected in the filters, this chart provides Share of Voice for the sub-topics you have selected. This chart uses volume of conversations to determine SOV."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!nodata && (
                            <div className="chart-type">
                                <span onClick={() => this.props.changeGraphType("pie")} className={this.props.graph_type === "pie" ? "active-chart" : ""}>
                                    <Icon name="pie chart" />
                                </span>
                                <span onClick={() => this.props.changeGraphType("bar")} className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Icon name="bar chart" />
                                </span>
                                <span onClick={() => this.props.changeGraphType("line")} className={this.props.graph_type === "line" ? "active-chart" : ""}>
                                    <Icon name="line chart" />
                                </span>
                            </div>
                        )}
                        {/* {!this.props.isResearchDashboard && this.props.graph_type !== "pie" && this.props.graph_type !== "bar" && this.props.dashboardPageType !== "temporaryInsights" && this.props.dashboardPageType !== "temporary" &&(
                            <Popup
                                content="Chart Comparison Filters"
                                position="bottom center"
                                size="tiny"
                                inverted
                                className="skiptranslate"
                                trigger={
                                    <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision : null)}>
                                        <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                    </div>
                                }
                            />
                        )} */}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && this.props.graph_type !== "line" && (
                            <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />
                        )}
                        {!nodata && <CustomCheckBox checked={this.props.hideCommonLegend} onClick={this.props.changehideCommonLegend} label="Show Legends" />}
                        {!nodata && (this.props.graph_type === "bar" || this.props.graph_type === "line") && (
                            <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                        )}
                        {!nodata && this.props.graph_type === "line" && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart dashboard-chart-slider" ref={this.container}>
                        <div
                            className={`chart-slider chart-slider-left ${this.props.data.data.length === 1 ? "disabled" : ""}`}
                            data-html2canvas-ignore="true"
                            onClick={this.decrement}>
                            <ArrowIcon />
                        </div>
                        <div className="chart-area" ref={this.chart}>
                            {this.getChart()}
                        </div>
                        <div
                            className={`chart-slider chart-slider-right ${this.props.data.data.length === 1 ? "disabled" : ""}`}
                            data-html2canvas-ignore="true"
                            onClick={this.increment}>
                            <ArrowIcon />
                        </div>
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        allTopics: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.topics : [],
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OverallShareOfVoiceForScenes);
